import React from "react";
import ReactGA from "react-ga";
import { render } from "react-snapshot";

import App from "./components/App/App";

import "./index.css";

ReactGA.initialize("UA-109320821-1", { debug: false, titleCase: false });

render(<App />, document.getElementById("root"));



// WEBPACK FOOTER //
// ./src/index.js